import { Option } from 'components/shared/ControlledFields/ControlledSelect';
import { Distance } from './types';
import { Arrangement, TravelCompensationType } from '../Arrangements/types';
import { TravelLineResponse } from '../Arrangements/hooks/TravelLines/types';
import { WorkAgreementDetails } from 'components/types';
import { TravelArrangementsData } from 'components/employee-portal/travel-arrangements/types';

type ProcessedWorkAgreementDetails = WorkAgreementDetails & {
  nrString: string;
};

const matcher = <T>(options: T[], key: string, matchKey: string) =>
  options?.find((item) => item[matchKey] === key);

export const countryCodeToOption = (
  distance: Distance | Partial<TravelArrangementsData>,
  codes: Option[],
  key: 'fromCountryCode' | 'toCountryCode' | 'countryCode'
) => {
  if (!codes || !Array.isArray(codes)) return null;

  const labelKey = distance[key];
  const match = matcher(codes, labelKey, 'value');
  if (!match) return null;

  return {
    label: codes.find((item) => item.value === labelKey)?.label ?? '',
    value: codes.find((item) => item.value === labelKey)?.value ?? ''
  };
};

export const workAgreementsToOption = (
  arrangement: Partial<TravelArrangementsData>,
  processedWorkAgreements: ProcessedWorkAgreementDetails[],
  key: 'waNr'
) => {
  if (!processedWorkAgreements || !Array.isArray(processedWorkAgreements))
    return null;

  const labelKey = String(arrangement?.[key]);
  const match = matcher(processedWorkAgreements, labelKey, 'nrString');
  if (!match) return null;

  return {
    nrString: match?.nrString ?? null,
    waId: match?.waId ?? null
  };
};

export const arrangementTypesToOption = (
  arrangement: Arrangement | Partial<TravelArrangementsData>,
  arrangementTypes: TravelCompensationType[],
  key: 'compensationTypeName'
) => {
  if (!arrangementTypes || !Array.isArray(arrangementTypes)) return null;

  const labelKey = arrangement?.[key];
  const match = matcher(arrangementTypes, labelKey, 'name');
  if (!match) return null;

  return {
    name: match?.name ?? '',
    id: match?.id ?? ''
  };
};

export const trvSetToOption = (
  travelLine: TravelLineResponse | Partial<TravelArrangementsData>,
  arrangements: Arrangement[],
  key: 'trvSetDescription'
) => {
  if (!arrangements || !Array.isArray(arrangements)) return null;

  const labelKey = travelLine?.[key];
  const match = matcher(arrangements, labelKey, 'description');
  if (!match) return null;

  return {
    description: match?.description ?? '',
    trvSetId: match?.trvSetId ?? ''
  };
};
